import React, { FC } from 'react';

import { SizeGuideActivator } from 'components/SizeGuide/SizeGuideActivator';

export const DescriptionSizeAndFit: FC<{
  department: string;
  setSizeGuideVisible: (boolean) => void;
}> = ({ department, setSizeGuideVisible }) => (
  <div className="size-and-fit">
    <p>
      Sizes and measurements may vary depending on the style of the item and how the brand fits. If you are not sure
      about a size or a fit, we recommend trying the product at a nearby luxury boutique.
    </p>
    <SizeGuideActivator
      department={department}
      margin="0"
      setSizeGuideVisible={() => {
        setSizeGuideVisible(true);
      }}
    />
  </div>
);
